import React from 'react';
import Table, { HeadsType } from '../../../Shared/CustomTable';
import { fixDecimals } from '../../../../helpers/helpers';
import {
  PLAYERS_CATEGORIE,
  STATS_CATEGORIE,
  TABLE_STATS_COLUMNS,
  METRICS_CATEGORIE, TABLE_METRICS_COLUMNS, FLAGGED_PLAYERS_LIMIT } from '../../../../config/constants';
import AccordionTable from './AccordionTable';
import TableHeader from './TableHeader';
import { Player, PlayersTable as PlayersTableProps } from '../types';
import { usePracticeViewerState } from 'store/hooks';

const playersHeader = [
  { style: { width: '33px', paddingLeft: 20, paddingRight: 20 }, isPinFlagCell: true, isSelectable: true },
  { content: 'PLAYER', isOrderly: true, style: { width: '143px' } },
  { content: 'NO.', isOrderly: true, style: { width: '50px' } },
  { content: 'POS.', isOrderly: true, style: { width: '50px' } },
  { content: 'COLOR', isOrderly: true, style: { width: '50px' } }
];

const statsAndMetricsHeader = (array: Array<string>) => {
  const headerArray = [
    { style: { width: '33px', paddingLeft: 20, paddingRight: 20 }, isPinFlagCell: true, isSelectable: true },
    { content: 'PLAYER', isOrderly: true, style: { width: 113 } }
  ];
  array.forEach(content => headerArray.push({ content, isOrderly: true, style: { width: '45px' as any }}));
  return headerArray;
};

const playersContent = (player: Player) => {
  const { name, jersey, position, color, playerId } = player;
  return {
    columns: [
      { isPinFlagCell: true, style: { paddingLeft: 20, paddingRight: 20, cursor: 'pointer' }  },
      { content: name, style: { fontWeight: 'bold' }  },
      {
        content: jersey,
        print: (content: string) => '#' + content
      },
      { content: position },
      {
        content: color,
        print: (content: string) => <div className="player-color" style={{ background: content }} />
      }
    ],
    id: playerId
  };
};

const statsContent = (player: Player) => {
  const { name, totals, playerId } = player;
  const { totalDist, hardEffortDist, maxSpeed, maxSustainedSpeed } = totals;
  return {
    columns: [
      { isPinFlagCell: true, style: { paddingLeft: 20, paddingRight: 20, cursor: 'pointer' } },
      { content: name, style: { fontWeight: 'bold' } },
      { content: fixDecimals(totalDist, 0) },
      { content: fixDecimals(hardEffortDist, 0) },
      { content: fixDecimals(maxSpeed, 2) },
      { content: fixDecimals(maxSustainedSpeed, 2) }
    ],
    id: playerId
  };
};

const PlayersTable = ({ currentTab, setCurrentTab, isProcessing, isNcaaGame } : PlayersTableProps) => {

  const { players = [] } = usePracticeViewerState();

  const getTableHeader = () : HeadsType<string> => {
    switch (currentTab) {
      case PLAYERS_CATEGORIE:
        return playersHeader;
      case STATS_CATEGORIE:
        return statsAndMetricsHeader(TABLE_STATS_COLUMNS);
      case METRICS_CATEGORIE:
        return statsAndMetricsHeader(TABLE_METRICS_COLUMNS);
      default:
        return playersHeader;
    }
  };

  const getTableContent = (player: Player) => {
    switch (currentTab) {
      case PLAYERS_CATEGORIE:
        return playersContent(player);
      case STATS_CATEGORIE:
        return statsContent(player);
      default:
        return playersContent(player);
    }
  };

  return (
    <>
      <div className="t-h-m">
        <TableHeader
          dropdown={currentTab}
          setDropdown={setCurrentTab}
        />
      </div>

      <div className="table-body">
        {currentTab !== METRICS_CATEGORIE ?
          <Table
            headers={getTableHeader()}
            rows={currentTab !== METRICS_CATEGORIE ? players.map(player => getTableContent(player)) as any : []}
            flagLimit={FLAGGED_PLAYERS_LIMIT}
            isPinnedStyle
            forceScope={isNcaaGame? 'NCAA_GAME' :undefined}
          />
            :
          <AccordionTable headers={getTableHeader()} isProcessing={isProcessing} />
        }
      </div>
    </>
  );
};

export default PlayersTable;